import { register } from 'async-ops';
import { getDefaultOptions, throwExceptionErrors } from '../../../utils/fetch';
import { callMdaePublicApi } from "../../../call-web-api";

export const EDIT_DOCUMENT = 'EDIT_DOCUMENT';

export const service = async (data) => {

  const response: any = await callMdaePublicApi({
    type: 'post',
    contentType: 'application/json',
    url: '/Api/Document/EditDocument',
    isRoutedApiCall: true,
    ...getDefaultOptions(),
    body: JSON.stringify(data)
  })
  throwExceptionErrors(response);
  return response;
};

const mockData = () => {
  return ([])
};

const mock = () => Promise.resolve(mockData());

register(EDIT_DOCUMENT, service, mock);
